import { render, staticRenderFns } from "./editMF.vue?vue&type=template&id=30bf65f9"
import script from "./editMF.vue?vue&type=script&lang=js"
export * from "./editMF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports